import { useMemo } from "react";
import { useStockArticles } from "@/hooks/queries/useStockArticles";
import { useStockMovements } from "@/hooks/queries/useStockMovements";
import { getStockMetrics } from "../stock-calculations";

export function useStockArticlesPageData(includeInactive: boolean) {
  const { data: articles = [], isLoading: loadingArticles } = useStockArticles(includeInactive);
  const { data: movements = [], isLoading: loadingMovements } = useStockMovements(articles);
  const metrics = useMemo(() => getStockMetrics(articles, movements), [articles, movements]);

  return {
    articles,
    movements,
    metrics,
    loadingArticles,
    loadingMovements,
  };
}
